import { Component, Field } from '@contember/interface'

export const PartnerPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
